import { DragHandle, GrayDownArrow } from '#assets/svg';
import { ICustomExerciseType } from '#types/exerciseTypes';
import { useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import styled from 'styled-components';
import { StyledListItem } from './styles';

interface SelectExerciseListProps {
  selectedExerciseList: ICustomExerciseType[];
  onClick: (exercise: ICustomExerciseType) => void;
  setSelectedExerciseList: (list: ICustomExerciseType[]) => void;
}
export const SelectedExerciseList = ({
  selectedExerciseList,
  onClick,
  setSelectedExerciseList
}: SelectExerciseListProps) => {
  const [open, setOpen] = useState(true);

  const onDragHandleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };

  const onDragEnd = (result: any) => {
    if (!result.destination) {
      return;
    }

    const items = Array.from(selectedExerciseList);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setSelectedExerciseList(items);
  };

  return (
    <div
      className="sticky top-0 pb-12 flex flex-col bg-[#17161b]"
      style={{ gap: open && selectedExerciseList.length > 0 ? '8px' : '0' }}
    >
      <SeletedExerciseHeader onClick={() => setOpen(!open)}>
        <div className="flex gap-4">
          <div>선택한 운동목록</div>
          <SelectedExerciseCount>
            {selectedExerciseList.length}
          </SelectedExerciseCount>
        </div>
        <StyledArrow open={open} />
      </SeletedExerciseHeader>

      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <StyledList
              ref={provided.innerRef}
              open={open}
              length={selectedExerciseList.length}
            >
              {selectedExerciseList.map((exercise, index) => {
                return (
                  <Draggable
                    key={exercise.name}
                    draggableId={exercise.name}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <ListItem
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        onClick={() => onClick(exercise)}
                        key={index}
                      >
                        <div className="flex gap-12">
                          <div
                            onClick={onDragHandleClick}
                            {...provided.dragHandleProps}
                          >
                            <DragHandle />
                          </div>
                          {exercise.name}
                        </div>
                        <SelectedExerciseOrder>
                          {index + 1}
                        </SelectedExerciseOrder>
                      </ListItem>
                    )}
                  </Draggable>
                );
              })}
            </StyledList>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};

const SeletedExerciseHeader = styled.div`
  display: flex;
  padding: 16px 20px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  border-radius: 12px;
  background: var(--bg-700, #262231);
`;

const SelectedExerciseCount = styled.div`
  display: flex;
  width: 28px;
  justify-content: center;
  align-items: center;
  gap: 16px;

  border-radius: 80px;
  background: var(--bg-500, #373245);
`;
const SelectedExerciseOrder = styled.div`
  display: flex;
  width: 20px;
  justify-content: center;
  align-items: center;
  text-align: center;

  border-radius: 80px;
  background: var(--Brand-400, #7750e9);

  color: var(--Gray-Scale-300, #d7d3de);
  text-align: center;

  /* NEW/body_03_medium */
  font-family: 'Pretendard Variable';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
`;

const StyledArrow = styled(GrayDownArrow)<{ open: boolean }>`
  //opne이 true일 때 rotate 180도
  transform: rotate(${props => (props.open ? '180deg' : '0deg')});
`;

const StyledList = styled.ol<{ open: boolean; length: number }>`
  display: flex;
  flex-direction: column;
  gap: 8px;

  // open이 true일 때 높이를 length * 58px로 설정
  max-height: ${props => (props.open ? `40vh` : '0')};
  overflow: auto;
  transition: height 0.5s ease-in-out;
`;

const ListItem = styled(StyledListItem)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  border: 1px solid var(--Brand-400, #7750e9);
`;
